import { render, staticRenderFns } from "./CompanyFee.vue?vue&type=template&id=edf5ce62&scoped=true&"
import script from "./CompanyFee.vue?vue&type=script&lang=js&"
export * from "./CompanyFee.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFee.vue?vue&type=style&index=0&id=edf5ce62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf5ce62",
  null
  
)

export default component.exports